/** @jsx jsx */

import { useState } from "react";
import {
  FullWidthInput,
  TextArea,
  ControllerSection,
  COLORS,
} from "../../style/styledComponents";
import { cloneDeep } from "lodash-es";
import { css, jsx } from "@emotion/react";
import XOptionsRadioButtons from "../PAGEBUILDER_UTILITY_COMPONENTS/XOptionsRadioButtons";
import ColorOptions from "../PAGEBUILDER_UTILITY_COMPONENTS/ColorOptions";
import BlockExpandableBar from "../PAGEBUILDER_UTILITY_COMPONENTS/BlockExpandableBar";
import ImageSelector, {
  imageData,
} from "../PAGEBUILDER_UTILITY_COMPONENTS/ImageSelector";
import CategoryExpandableBar from "../PAGEBUILDER_UTILITY_COMPONENTS/CategoryExpandableBar";
import { BLOCKNAMES, BLOCKS } from "../../blocks";
import BlockColorOptions from "../PAGEBUILDER_UTILITY_COMPONENTS/BlockColorOptions";
import RichTextEditor from "../PAGEBUILDER_UTILITY_COMPONENTS/RichTextEditor";
import VerticalPaddingSliders from "../PAGEBUILDER_UTILITY_COMPONENTS/VerticalPaddingSliders";
import ControlledArrayItems from "../PAGEBUILDER_UTILITY_COMPONENTS/ControlledArrayItems";
import { videoData } from "../PAGEBUILDER_UTILITY_COMPONENTS/VideoSelector";

interface Props {
  content: any;
  index: number;
  handleBlockChange: Function;
  disabledStyle: string;
}

export const staffBlockInit = {
  title: "Title Text",
  subtitle: "subtitle",
  titlePosition: 0,
  textSize: 0,
  contentWidth: 0,
  items: [],
  imageData: { imageID: "", vFocus: 50, hFocus: 50, crop: true },
  titleColor: 0,
  textColor: 0,
  bgColor: 0,
  vPaddingTop: 30,
  vPaddingBottom: 30,
};

export type staffType = {
  image: imageData;
  video: videoData;
  label1: string;
  label2: string;
};

const initStaff: staffType = {
  image: { imageID: "", vFocus: 50, hFocus: 50, crop: true },
  video: { videoID: "", aspectRatioX: 16, aspectRatioY: 9 },
  label1: "New Item",
  label2: "Bottom label",
};

export const StaffBlockControl = ({
  content,
  index,
  handleBlockChange,
  disabledStyle,
}: Props) => {
  const handleValueChange = (key: string, value: any) => {
    const newContent = cloneDeep(content);
    newContent[key] = value;
    handleBlockChange({ ...newContent }, index);
  };

  return (
    <>
      <CategoryExpandableBar title="TEXT" index={index}>
        <ControllerSection>
          <label>Title</label>
          <FullWidthInput
            type="text"
            value={content.title}
            onChange={(e) => handleValueChange("title", e.target.value)}
          />
        </ControllerSection>

        <ControllerSection>
          <label htmlFor="subtitle">Subtitle</label>
          <FullWidthInput
            type="text"
            value={content.subtitle}
            onChange={(e) => handleValueChange("subtitle", e.target.value)}
          />{" "}
        </ControllerSection>
        <ControllerSection>
          <span>Title Position</span>
          <XOptionsRadioButtons
            propName="titlePosition"
            currentVal={content.titlePosition}
            handleChange={handleValueChange}
            index={index}
            labels={["left", "center", "right"]}
          />
        </ControllerSection>
        <ControllerSection>
          <span>Label Size</span>
          <XOptionsRadioButtons
            propName="textSize"
            currentVal={content.textSize}
            handleChange={handleValueChange}
            index={index}
            labels={["Normal", "Large", "XL"]}
          />
        </ControllerSection>
      </CategoryExpandableBar>
      <CategoryExpandableBar title="STAFF / ITEMS">
        <ControlledArrayItems
          label="Staff:"
          itemType={{
            label1: { type: "text", label: "Upper label:" },
            label2: { type: "text", label: "Bottom label:" },
            image: { type: "image", label: "Image:" },
            video: { type: "video", label: "Video:" },
          }}
          handleValueChange={handleValueChange}
          currentValue={content.items}
          propName="items"
          itemName="Staff Member"
          initItem={initStaff}
        />
      </CategoryExpandableBar>
      <CategoryExpandableBar title="BACKGROUND IMAGE" index={index}>
        <ControllerSection>
          <ImageSelector
            currentValue={content.imageData}
            handleValueChange={handleValueChange}
            label="Background Image:"
            propName="imageData"
            croppedByDefault
          />
        </ControllerSection>
      </CategoryExpandableBar>
      <CategoryExpandableBar title="BLOCK OPTIONS" index={index}>
        <ControllerSection>
          <span>Content Width:</span>
          <XOptionsRadioButtons
            propName="contentWidth"
            currentVal={content.contentWidth}
            handleChange={handleValueChange}
            index={index}
            labels={["Full-width", "Extra padding"]}
          />
        </ControllerSection>
        <VerticalPaddingSliders
          vPaddingBottom={content.vPaddingBottom}
          vPaddingTop={content.vPaddingTop}
          handleValueChange={handleValueChange}
        />
      </CategoryExpandableBar>
      <BlockColorOptions
        titleColor={content.titleColor}
        bgColor={content.bgColor}
        textColor={content.textColor}
        handleValueChange={handleValueChange}
      />
    </>
  );
};
export default StaffBlockControl;
